export default __webpack_public_path__ + "static/media/phone.f6967dda.webp";